import { EnvironmentProviders, Provider } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient } from '@angular/common/http';

import { appConfig } from './app.config';
import { JwtInterceptor } from './core/helpers/jwt.interceptor';
import { ErrorInterceptor } from './core/helpers/error.interceptor';
import { FakeBackendInterceptor } from './core/helpers/fake-backend';

// Backend-agnostic providers shared by the production bootstrap (main.ts) and
// the e2e bootstrap (main.e2e.ts). The Firebase providers differ between the
// two entries — live project vs local emulators — and are declared in each
// main file, so emulator wiring never enters the production import graph while
// this (long, security-sensitive) interceptor/provider list stays single-source.
export function buildCoreProviders(): (Provider | EnvironmentProviders)[] {
  return [
    provideAnimations(),
    provideHttpClient(),
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: FakeBackendInterceptor, multi: true },
    ...appConfig.providers,
  ];
}
